export default __webpack_public_path__ + "static/media/StewardpointLogo.20b4a6df.svg";